import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValueDefault } from '@/main/models/common';

// Redux
import {
  GetPartTypesByDirectAssignCriteria,
  GetPartTypesBySupplierAndVehicleManufacturer,
  savePartType
} from './index';

// Api's
import { partTypeApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getPartTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValueDefault[]>> = yield call(
      partTypeApi.getDomain
    );
    if (response.data.result) {
      yield put(savePartType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(savePartType(null, true, resultError.messagesDataError));
    }
  }
}

export function* getPartTypesBySupplierAndVehicleManufacturerSaga(
  action: GetPartTypesBySupplierAndVehicleManufacturer
) {
  try {
    const response: AxiosResponse<Result<KeyValueDefault[]>> = yield call(
      partTypeApi.GetPartTypesBySupplierAndVehicleManufacturer,
      action.payload.guidSupplier,
      action.payload.guidVehicleManufacturer
    );
    if (response.data.result) {
      yield put(savePartType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(savePartType(null, true, resultError.messagesDataError));
    }
  }
}

export function* getPartTypesByDirectAssignCriteriaSaga(
  action: GetPartTypesByDirectAssignCriteria
) {
  try {
    const response: AxiosResponse<Result<KeyValueDefault[]>> = yield call(
      partTypeApi.getPartTypeByDirectAssignCriteria,
      action.payload.guidClaim,
      action.payload.guidQuote,
      action.payload.guidQuoteProcurement,
    );
    if (response.data.result) {
      yield put(savePartType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);
      yield put(savePartType(null, true, resultError.messagesDataError));
    }
  }
}
